import { render, staticRenderFns } from "./EssentialsShop.vue?vue&type=template&id=09f6a94b&"
import script from "./EssentialsShop.vue?vue&type=script&lang=js&"
export * from "./EssentialsShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports